/*
 * @Descripttion:
 * @Date: 2024-08-06 10:12:42
 */
export const MAX_SELECT_LENGTH = 2000;

// 资质状态 certificationStatus
export const CERTIFICATION_STATUS = {
  0: { label: '未上传', value: '0' },
  1: { label: '待审核', value: '1' },
  2: { label: '服务商审核通过', value: '2' },
  3: { label: '服务商审核不通过', value: '3' },
  4: { label: '平台审核通过', value: '4' },
  5: { label: '平台审核不通过', value: '5' }
};
// 入驻状态 inStatus
export const IN_STATUS = {
  1: { label: '未入驻', value: '1' },
  2: { label: '已入驻', value: '2' },
  3: { label: '拒绝入驻', value: '3' },
  4: { label: '已退出', value: '4' }
};
// 支付通道状态 payStatus
export const OPEN_STATUS_MAPPING = {
  1: { label: '未开通', value: '1' },
  2: { label: '开通中', value: '2' },
  3: { label: '开通成功', value: '3' },
  4: { label: '开通失败', value: '4' }
};
// 实名认证状态 userAuthStatus
export const USER_AUTH_STATUS = {
  1: { label: '已实名', value: '1' },
  2: { label: '未实名', value: '2' }
};
// 职业认证状态 OccupationAuthStatus
export const OCCUPTION_AUTH_STATUS = {
  1: { label: '未认证', value: '1' },
  2: { label: '已认证', value: '2' }
  // 2: { label: '已认证', value: '2' }
};

// 企业签约状态 signStatus
export const SIGN_STATUS = {
  0: { label: '未签约', value: '0' },
  1: { label: '签约中', value: '1' },
  2: { label: '已签署', value: '2' },
  3: { label: '签署失败', value: '3' }
};

export const AUDITOR_MAPPING = {
  1: { label: '服务商待审核', value: '1' },
  2: { label: '平台待审核', value: '2' }
};

//是否过期  0 未过期(默认)  1 已过期
export const IS_OVERDUE = {
  0: { label: '未过期', value: 0 },
  1: { label: '已过期', value: 1 }
};

//结算状态 0未结算1结算中2已结算
export const SETTLEMENT_STATUS = {
  0: { label: '未结算', value: '0' },
  1: { label: '结算中', value: '1' },
  2: { label: '已结算', value: '2' }
};

//自审状态 1审核中2审核通过3审核未通过
export const AUDIT_STATUS = {
  0: { label: '未提交审核', value: 0 },
  1: { label: '审核中', value: 1 },
  2: { label: '审核通过', value: 2 },
  3: { label: '审核未通过', value: 3 }
};

//用户状态
export const ENABLED_STATUS = {
  1: { label: '已启用', value: 1 },
  2: { label: '已停用', value: 2 },
  3: { label: '已注销', value: 3 },
  4: { label: '已冻结', value: 4 }
};

//入驻状态,1未入驻,2已入驻,3拒绝入驻,4已退出
export const SETTLED_STATUS = {
  1: { label: '未入驻', value: 1 },
  2: { label: '已入驻', value: 2 },
  3: { label: '拒绝入驻', value: 3 },
  4: { label: '已退出', value: 4 }
};

//结算状态,1未结算,2已结算,3结算中
export const SETTLEMENT_ACTIVITY_STATUS = {
  1: { label: '未结算', value: 1 },
  2: { label: '已结算', value: 2 },
  3: { label: '结算中', value: 3 }
};

//人员状态,1-已注销,0-正常
export const CANCEL_STATUS = {
  0: { label: '正常', value: '0' },
  1: { label: '已注销', value: '1' },
  2: { label: '已冻结', value: '2' }
};

//平台审核状态
export const PLATFORM_AUDIT_STATUS = {
  0: { label: '未提交审核', value: 0 },
  1: { label: '审核中', value: 1 },
  2: { label: '审核通过', value: 2 },
  3: { label: '审核未通过', value: 3 }
};

//合同签署状态
export const HETONG_STATUS = {
  0: { label: '未签署', value: '0' },
  1: { label: '签署中', value: '1' },
  2: { label: '已签署', value: '2' },
  3: { label: '签署失败', value: '3' }
};

/**
 * 用户类型: 1-自然人  2-个体工商户
 **/
export const USER_TYPE = {
  1: { label: '自然人', value: '1' },
  2: { label: '个体工商户', value: '2' }
};

// 项目执行状态 projectStatus
export const PROJECT_STATUS = {
  0: { label: '已停用', value: '0' },
  1: { label: '待执行', value: '1' },
  2: { label: '执行中', value: '2' },
  3: { label: '待执行', value: '3' }
};

// 实名状态 realNameStatus
export const REALNAME_STATUS = {
  1: { label: '已实名', value: '1' },
  2: { label: '未实名', value: '2' }
};

// 授权状态 checkStatus
export const CHECK_STATUS = {
  0: { label: '未授权', value: '0' },
  1: { label: '已授权', value: '1' }
};

// 支付通道开通状态 openStatus
export const OPEN_STATUS = {
  0: { label: '未开通', value: '0' },
  1: { label: '开通中', value: '1' },
  2: { label: '开通成功', value: '2' },
  3: { label: '开通失败', value: '3' }
};

export const QUESTION_TYPE = {
  [-3]: {
    label: '定位题',
    value: -3
  },
  29: {
    label: '时刻题',
    value: 29
  },
  31: {
    label: '时间段题',
    value: 31
  },
  [-2]: {
    label: '时间题',
    value: -2,
    children: {
      1: {
        label: '时间段题',
        value: -2,
        secondType: 1
      },
      2: {
        label: '时刻题',
        value: -2,
        secondType: 2
      }
    }
  },
  [-1]: {
    label: '目标题',
    value: -1
  },
  1: {
    label: '单选题',
    value: 1
  },
  2: {
    label: '多选题',
    value: 2
  },
  3: {
    label: '单选投票题',
    value: 3
  },
  4: {
    label: '单项填空题',
    value: 4
  },
  5: {
    label: '多项填空题',
    value: 5
  },
  6: {
    label: '打分题',
    value: 6
  },
  7: {
    label: '地址',
    value: 7
  },
  8: {
    label: '上传附件',
    value: 8
  },
  9: {
    label: '上传pdf',
    value: 9
  },
  10: {
    label: '上传word',
    value: 10
  },
  11: {
    label: '上传excel',
    value: 11
  },
  12: {
    label: '上传ppt',
    value: 12
  },
  13: {
    label: '上传图片',
    value: 13
  },
  14: {
    label: '时间题',
    value: 14
  },
  15: {
    label: '月度题',
    value: 15
  },
  16: {
    label: '定位题',
    value: 16
  },
  17: {
    label: '描述题',
    value: 17
  },
  18: {
    label: '描述题',
    value: 18
  },
  19: {
    label: '数字填空题',
    value: 19
  },
  20: {
    label: '签名题',
    value: 20
  },
  21: {
    label: '签到题', // 未使用
    value: 21
  },
  22: {
    label: '姓名填空题',
    value: 22
  },
  23: {
    label: '下拉框',
    value: 23
  },
  24: {
    label: '多级下拉框',
    value: 24
  },
  25: {
    label: '排序',
    value: 25
  },
  26: {
    label: '段落说明',
    value: 26
  },
  27: {
    label: '分页',
    value: 27
  },
  28: {
    label: 'table页',
    value: 28
  },
  30: {
    label: '受访者来源',
    value: 30
  }
};
